import { VideoPlayer } from "./VideoPlayer";

/**
 * Player for video files with alpha channel.
 * {@link http://www.sciencelifeny.com/transparency/transparency.html|Demo}
 * {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement|Reference to media API}
 *
 * @emits VideoPlayerAlpha#play
 * @emits VideoPlayerAlpha#pause
 * @emits VideoPlayerAlpha#ended
 * @emits VideoPlayerAlpha#error
 **/
export class VideoPlayerAlpha extends VideoPlayer {

    protected _bufferCanvas;
    protected _bufferCanvasContext;

    public destroy() {
        this._bufferCanvas        = null;
        this._bufferCanvasContext = null;

        super.destroy();
    }

    protected createElements() {
        super.createElements();

        this._bufferCanvas        = document.createElement("canvas");
        this._bufferCanvas.width = this._video.videoWidth
        this._bufferCanvas.height = this._video.videoHeight
        this._bufferCanvasContext = this._bufferCanvas.getContext('2d');
    }

    protected setResolution() {
        this._width  = this._video.videoWidth;
        this._height = this._video.videoHeight / 2;
    }

    protected processFrame() {
        this._bufferCanvasContext.drawImage(this._video, 0, 0);

        let image     = this._bufferCanvasContext.getImageData(0, 0, this._width, this._height),
            imageData = image.data,
            alphaData = this._bufferCanvasContext.getImageData(0, this._height, this._width, this._height).data;

        for (let i = 3, len = imageData.length; i < len; i = i + 4) {
            imageData[i] = alphaData[i - 1];
        }

        this._outputCanvasContext.putImageData(image, 0, 0, 0, 0, this._width, this._height);
        this._outputTexture.update();
    }
}
